<template>
  <form id="payment-form">
    <div id="payment-element">
    </div>

    <button id="submit" @click="handleSubmit" :disable="disabled || loading"
            class="button-recharge v-btn theme--light coloricon">
      <span id="button-text">
        {{$vuetify.t("$vuetify.Braintree.recharge")}}
      </span>
    </button>

    <waiting-popup-message :showPopup="loading"
                           @hidePopup="loading=false">
      <template #title>
        {{$vuetify.t("$vuetify.Stripe.waitingPayment")}}
      </template>
      {{$vuetify.t("$vuetify.Stripe.waitingPaymentMessage")}}
    </waiting-popup-message>


    <generic-popup-response-status :showPopup="showPopupSuccess"
                                   :success="true"
                                   @hidePopup="showPopupSuccess=false">
      <template #title>
        {{$vuetify.t("$vuetify.Stripe.successPayment")}}
      </template>
      {{$vuetify.t("$vuetify.Stripe.successPaymentMessage")}}
      {{successMessage}}
    </generic-popup-response-status>

    <generic-popup-response-status :showPopup="showPopupError"
                                   :success="false"
                                   @hidePopup="showPopupError=false">
      <template #title>
        {{$vuetify.t("$vuetify.Stripe.errorPayment")}}
      </template>
      {{$vuetify.t("$vuetify.Stripe.errorPaymentMessage")}}
      {{errorMessage}}
    </generic-popup-response-status>


    <div id="payment-message" class="hidden"></div>


  </form>
</template>

<script>

  //https://stripe.com/docs/payments/quickstart
  //https://stripe.com/docs/js/elements_object/create
  //https://stripe.com/docs/payments/accept-a-payment-deferred

  import Vue from 'vue';
  import { StripePlugin } from '@vue-stripe/vue-stripe';
  import WaitingPopupMessage from './waitingPopupMessage.vue'
  import GenericPopupResponseStatus from "@/components/genericPopupResponseStatus.vue";
  import {getAppCustomerSelectionUrl} from "@/helpers/location";

  let elements;

  export default {
    mounted() {
      let vm = this;
      Vue.use(StripePlugin, {
        pk: process.env.VUE_APP_STRIPE_PUB_API,
        locale: vm.locale,
        stripeAccount: vm.stripeAccount
      });
      this.initialize();
      this.checkStatus();
    },
    data() {
      return {
        loading: false,
        disabled: false,
        showPopupSuccess: false,
        showPopupError: false,
        errorMessage: "",
        successMessage: "",
      }
    },
    props: {
      paymentAmount: {
        type: Number,
        default: 0.0
      },
      locale: {
        type: String,
        default: 'it'
      },
      stripeAccount: {
        type: String,
        default: ''
      }
    },
    methods: {
      async initialize() {
        const options = {
          locale: this.locale,
          mode:'payment',
          currency:'eur',
          amount: this.paymentAmount * 100,
          appearance:{
            theme: 'stripe'
          }
        };
        elements = this.$stripe.elements(options);

        const paymentElementOptions = {
          layout: "tabs"
        };
        const paymentElement = elements.create("payment", paymentElementOptions);
        paymentElement.mount("#payment-element");
      },

      async handleSubmit(e) {
        e.preventDefault();
        this.setLoading(true);

        const {error: submitError} = await elements.submit();
        if (submitError) {
          this.showMessage(submitError);
          return;
        }

        const STRIPE_CHECKOUT_MUTATION = require("../graphql/mutations/stripeCheckout.gql")
        const result = await this.$apollo.mutate({
          client: "clientPrivate",
          mutation: STRIPE_CHECKOUT_MUTATION,
          variables: {
            amount: this.paymentAmount
          }
        })

        if (result.data.stripeCheckout.result.success) {
          const { error } = await this.$stripe.confirmPayment({
            elements,
            clientSecret: result.data.stripeCheckout.result.clientSecret,
            confirmParams: {
              return_url: `${location.protocol + '//' + location.host}/#/credit/`
            }
          });

          if (error.type === "card_error" || error.type === "validation_error") {
            this.showMessage(error.message,true);
          } else {
            this.showMessage( $vuetify.t("$vuetify.Stripe.unexpectedError"),true);
          }
        }else{
          this.showMessage($vuetify.t("$vuetify.Stripe.unexpectedError"),true);
        }
        this.setLoading(false);
      },
      
      // Fetches the payment intent status after payment submission
      async checkStatus() {
        const clientSecret = new URLSearchParams(window.location.search).get(
            "payment_intent_client_secret"
        );

        if (!clientSecret) {
          return;
        }else{
          history.replaceState({},"","/#credit");
        }

        const { paymentIntent } = await this.$stripe.retrievePaymentIntent(clientSecret);

        switch (paymentIntent.status) {
          case "succeeded":
            this.showMessage("",false);
            break;
          case "processing":
            this.showMessage($vuetify.t("$vuetify.Stripe.processingPayment"), false);
            break;
          case "requires_payment_method":
            this.showMessage("", true);
            break;
          default:
            this.showMessage("",true);
            break;
        }
      },
      showMessage(messageText,error) {
        if(error){
          this.showPopupError = true
          this.showPopupSuccess = true
          this.loading = false
          this.errorMessage = messageText
        }else{
          this.showPopupError = false
          this.showPopupSuccess = true
          this.loading = false
          this.successMessage = messageText
        }
      },
      setLoading(isLoading) {
        this.loading = isLoading;
      }
    },
    components: {
      WaitingPopupMessage,
      GenericPopupResponseStatus
    }
  };

</script>
